var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pict',{staticClass:"connected-image__image m-auto s:max-w-auto m:max-w-xs l:max-w-auto",attrs:{"block-name":"connected-image","default":_vm.imageProps.default,"sources":_vm.imageProps.sources,"alt":_vm.$t('alt')}})}
var staticRenderFns = []

export { render, staticRenderFns }